import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    fetchUsers,
    selectFullyConnectedUsers,
    selectPartiallyConnectedUsers,
    selectInactiveUsers,
} from '../../../usersSlice';
import connectedLogo from '../../../assets/connected.svg';
import incompleteLogo from '../../../assets/iconnotComplete.svg';
import inactiveLogo from '../../../assets/off.svg';
import downloadLogo from '../../../assets/download.svg';
import userLogo from '../../../assets/allUser.svg';
import { RootState, AppDispatch } from '../../../store';
import { exportToCsv } from '../../../service/csvExporter';

interface UserData {
    id: number;
    active: boolean;
    address?: string;
    agencyName?: string;
    email: string;
    phoneNumber?: string;
    linkedin?: string;
    insta?: string;
    gmb?: string;
    fb?: string;
}

function Users() {
    const dispatch = useDispatch<AppDispatch>();
    const fullyConnectedUsers = useSelector(selectFullyConnectedUsers);
    const partiallyConnectedUsers = useSelector(selectPartiallyConnectedUsers);
    const inactiveUsers = useSelector(selectInactiveUsers);
    const connected = useSelector((state: RootState) => state.users.connected);
    const incomplete = useSelector((state: RootState) => state.users.incomplete);
    const inactive = useSelector((state: RootState) => state.users.inactive);
    const [loading, setLoading] = useState(false);
    const headers = ['agencyName', 'email', 'fb', 'insta', 'linkedin', 'gmb'];

    useEffect(() => {
        dispatch(fetchUsers(true));
    }, [dispatch]);

    const handleUsersExportClick = (usersData: UserData[], filename: string) => {
        setLoading(true);
        try {
            exportToCsv(filename, headers, usersData);
        } catch (error) {
            console.error('Erreur lors de la préparation des données pour le CSV ', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="inline-flex flex-col justify-start items-stretch w-[calc(50%-20px)] h-auto rounded bg-white px-[20px] py-[24px] gap-[20px] shadow-lg">
            <div className="flex items-center justify-start gap-2 w-full">
                <img className="h-[40px]" src={userLogo} alt="logo user" />
                <div className="text-neutral-900 text-heavy font-semibold leading-normal">
                    Comptes utilisateurs
                </div>
            </div>
            <div className="flex justify-between">
                <div className="flex flex-col pr-[20px]">
                    <div className="flex flex-col items-start flex-wrap content-start">
                        <img
                            className="m-0 w-[24px] h-[24px]"
                            src={connectedLogo}
                            alt="connected logo"
                        />
                        <span className="text-medium my-[5px]">Connectés</span>
                        <span className="text-heavy font-medium text-dark-gray mb-[5px]">
                            {connected}
                        </span>
                        <button
                            className="bg-transparent"
                            onClick={() =>
                                handleUsersExportClick(
                                    fullyConnectedUsers,
                                    'fully_connected_users.csv',
                                )
                            }
                            disabled={loading}
                        >
                            <img src={downloadLogo} alt="download logo" />
                        </button>
                    </div>
                </div>
                <div className="flex flex-col pr-[20px]">
                    <div className="flex flex-col items-start flex-wrap content-start">
                        <img
                            className="m-0 w-[24px] h-[24px]"
                            src={incompleteLogo}
                            alt="incomplete logo"
                        />
                        <span className="text-medium my-[5px]">Incomplet</span>
                        <span className="text-heavy font-medium text-dark-gray mb-[5px]">
                            {incomplete}
                        </span>
                        <button
                            className="bg-transparent"
                            onClick={() =>
                                handleUsersExportClick(
                                    partiallyConnectedUsers,
                                    'partially_connected_users.csv',
                                )
                            }
                            disabled={loading}
                        >
                            <img src={downloadLogo} alt="download logo" />
                        </button>
                    </div>
                </div>
                <div className="flex flex-col pr-[20px]">
                    <div className="flex flex-col items-start flex-wrap content-start">
                        <img
                            className="m-0 w-[24px] h-[24px]"
                            src={inactiveLogo}
                            alt="inactive logo"
                        />
                        <span className="text-medium my-[5px]">Inactif</span>
                        <span className="text-heavy font-medium text-dark-gray mb-[5px]">
                            {inactive}
                        </span>
                        <button
                            className="bg-transparent"
                            onClick={() =>
                                handleUsersExportClick(inactiveUsers, 'inactive_users.csv')
                            }
                            disabled={loading}
                        >
                            <img src={downloadLogo} alt="download logo" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Users;
